import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { TrainingQualificationsBulkEditSelectionHasMixedValues } from '../../../../types';

@Component({
  selector: 'wilson-training-qualifications-bulk-edit-notes-section',
  imports: [
    FormsModule,
    NzCollapseModule,
    NzFormModule,
    ReactiveFormsModule,
    TranslatePipe,
    NzInputModule,
  ],
  templateUrl:
    './training-qualifications-bulk-edit-notes-section.component.html',
  styleUrl: './training-qualifications-bulk-edit-notes-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrainingQualificationsBulkEditNotesSectionComponent {
  @Input() active: boolean | null = true;
  @Input() disabled: boolean | null = false;

  @Input() notesFormControl: FormControl<string | null> = new FormControl<
    string | null
  >('', [Validators.maxLength(420)]);

  @Input() hasMixedValues: Pick<
    TrainingQualificationsBulkEditSelectionHasMixedValues,
    'notes'
  > = {
    notes: false,
  };
  @Input() containsTrainingsFromDigitalProvider = false;
}
